import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import { Icon } from '@eti/components';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import ResetButton from './ResetButton';

const headerWrapperStyles = css`
  border-top: 1px dotted ${etiColors.grayScale[9]};
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  padding: 15px 0;

  @media ${mediaQueries.medium.up} {
    border-top: none;
  }
`;

const clickable = css`
  cursor: pointer;
`;

const headerStyles = css`
  display: flex;
  line-height: 19px;
`;

const labelStyles = css`
  color: ${etiColors.black};
  display: flex;
  font-size: 0.875rem;
  font-weight: 700;
`;

const controlsStyles = css`
  color: ${etiColors.grayScale[10]};
  display: flex;
`;

const controlButtonStyles = css`
  align-items: center;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  margin-left: 24px;
  outline: inherit;
  padding: 0;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 24px;
  }

  @media ${mediaQueries.medium.up} {
    margin-left: 16px;

    [dir='rtl'] & {
      margin-left: 0;
      margin-right: 16px;
    }
  }
`;

const toggleIconStyles = (isOpen) => css`
  transform: rotate(${isOpen ? '180deg' : '0deg'});
`;

// eslint-disable-next-line react/prop-types
const ToggleIcon = ({ isOpen, ...rest }) => <Icon className={toggleIconStyles(isOpen)} {...rest} />;

const separatorStyles = css`
  display: inline-block;
  padding: 0 3px;
`;

const FilterHeader = ({
  destinationName,
  isOpen,
  isToggleable = true,
  label,
  name,
  onClick,
  onReset,
  originName,
  shouldShowResetButton,
}) => {
  const handleReset = (e) => {
    if (isFunction(onReset)) {
      onReset();
      e.stopPropagation();
    }
  };

  return (
    <header
      className={cx(headerWrapperStyles, `header ${isToggleable ? clickable : ''}`)}
      data-testid={`resultPage-${name}-header`}
      {...(isToggleable && { onClick })}
    >
      <div className={headerStyles}>
        <div className={labelStyles}>
          {label || (
            <>
              <span>{originName}</span>
              <span className={separatorStyles}>–</span>
              <span>{destinationName}</span>
            </>
          )}
        </div>
        {shouldShowResetButton && (
          <ResetButton
            dataTestId={`resultPage-filterHeader-${name}FilterResetButton-button`}
            onClick={handleReset}
          />
        )}
      </div>
      {isToggleable && (
        <div className={cx('controls', controlsStyles)}>
          <button
            className={controlButtonStyles}
            data-testid={`resultPage-filterHeader-${name}ToggleButton-button`}
            type="button"
          >
            <ToggleIcon
              color={etiColors.grayScale[8]}
              id="chevron-down"
              isOpen={isOpen}
              size="1.2rem"
            />
          </button>
        </div>
      )}
    </header>
  );
};

FilterHeader.propTypes = {
  destinationName: PropTypes.string,
  isOpen: PropTypes.bool,
  isToggleable: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
  onReset: PropTypes.func,
  originName: PropTypes.string,
  shouldShowResetButton: PropTypes.bool,
};

export default FilterHeader;
